import { TableCell } from 'src/pages/OfferPage/TableSvgOrganizer/TableCell';

export const PureTableCell = (props: any) => {
  const {
    col,
    row,
    showWrapper,
    showIcon,
    measurementSystem
  } = props;
  return (
    <TableCell
      width={col.data === "manufacturer_name" || col.data === "custom_description" ? "200" : "width" in col ? col.width : "auto"}
      numeric={col.numeric}
      cellCallback={col.cellCallback}
      icon={null}
      hasWrapper={showWrapper}
      hasIcon={showIcon}
    >
      {col.render(row[col.data], row, {
        measurementSystem: measurementSystem,
      })}
    </TableCell>
  );
};
